

















import { defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
  props: {
    src: {
      type: String,
      default: () => '',
    },
    width: {
      type: String,
      default: () => '',
    },
    height: {
      type: String,
      default: () => '',
    },
    backgroundColor: {
      type: String,
      default: '#fff',
    },
  },
  setup() {
    const isLoading = ref(true);
    const onImageLoaded = () => {
      isLoading.value = false;
    };

    return {
      isLoading,
      onImageLoaded,
    };
  },
});
